import script from "./select-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./select-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./select-setting-ly.vue?vue&type=style&index=0&id=558c8e89&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558c8e89"]])

export default __exports__